import { createQueryStringToggleHook } from "../../../../../stores/useQueryState";

export const tireBrandsParamName = "brands";

export const useTireBrands = createQueryStringToggleHook(
  tireBrandsParamName,
  []
);
